import { Bell, Mail, MessageSquare, Smartphone } from 'lucide-react';

const CHANNEL_ICON_COMPONENTS = {
  email: Mail,
  sms: MessageSquare,
  push: Smartphone,
  whatsapp: MessageSquare,
  wechat: MessageSquare,
};

const CHANNEL_ICON_NAMES = {
  email: 'Mail',
  sms: 'MessageSquare',
  push: 'Smartphone',
  whatsapp: 'MessageSquare',
  wechat: 'MessageSquare',
};

export const getNotificationChannelIcon = (channel, fallbackIcon = Bell) => (
  CHANNEL_ICON_COMPONENTS[channel] || fallbackIcon
);

export const getNotificationChannelIconName = (channel, fallbackName = 'Bell') => (
  CHANNEL_ICON_NAMES[channel] || fallbackName
);
